import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Container = styled.div`
  display: flex;
  padding: 16px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  flex: 1 0 0;
  border-radius: 4px;
  border: 1px solid ${ct({ Light: Colors.DarkerText, Dark: Colors.DarkerText })};
  background: ${ct({ Light: Colors.DarkestMiddle, Dark: Colors.DarkestMiddle })};
  margin-top: 16px;
  margin-bottom: 16px;
  min-width: 208px;
`;
